import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { CustomizerSettingsService } from 'shared/src/services/customizer-settings.service';
import WaveSurfer from 'wavesurfer.js';

export interface AudioTrack {
  title: string;
  imagePath: string;
  audioPath: string;
  sourceTextPath?: string;
  narrator?: 'male' | 'female';
}

@Component({
  selector: 'app-audio-track',
  imports: [],
  templateUrl: './audio-track.component.html',
  styleUrl: './audio-track.component.scss',
})
export class AudioTrackComponent implements AfterViewInit, OnDestroy {
  @ViewChild('waveform') waveformEl: ElementRef;

  @Input() data: AudioTrack;

  @Output() onPlayed = new EventEmitter<AudioTrackComponent>();

  wavesurfer: WaveSurfer;
  isPlaying = false;

  constructor(private themeService: CustomizerSettingsService) {}

  ngAfterViewInit(): void {
    this.wavesurfer = WaveSurfer.create({
      container: this.waveformEl.nativeElement,
      height: 28,
      barWidth: 2,
      barGap: 2,
      barRadius: 2,
      cursorWidth: 0,
      waveColor: '#bdbec0',
      //waveColor: this.themeService.isDark() ? '#FBFBFB8C' : '#26272F8C',
      progressColor: '#31BC6D',
      cursorColor: 'navy',
      url: this.data.audioPath,
    });

    this.wavesurfer.on('play', () => {
      this.isPlaying = true;
      this.onPlayed.emit(this);
    });

    this.wavesurfer.on('pause', () => (this.isPlaying = false));
    this.wavesurfer.on('finish', () => (this.isPlaying = false));
  }

  ngOnDestroy(): void {
    //TODO: unsibscribe from the events as well
    if (this.wavesurfer) {
      this.wavesurfer.destroy();
    }
  }

  playPause(): void {
    this.wavesurfer.playPause();
  }

  pause(): void {
    this.wavesurfer.pause();
  }
}
